import React,{useState,useEffect,useRef} from 'react';
import {connect} from 'react-redux';

import {currentRouteSet} from '../../actions/actions';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid'; 
import {BrowserRouter as Router,Route,Link} from 'react-router-dom'
import {pathSpliter,dateTimeFormat,currentDateTime,getDateTimeFromISODT,currentDateStartTime,currentDateEndTime} from '../../lib/functions'
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import axios from 'axios';
import HorizontalSplitIcon from '@material-ui/icons/HorizontalSplit';
import Button from '@material-ui/core/Button';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import ReceiptIcon from '@material-ui/icons/Receipt';
import DateFnsUtils from '@date-io/date-fns'; // choose your libs
import {API_URL} from '../../config.json';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import SearchIcon from '@material-ui/icons/Search';
import moment from 'moment';
import _ from 'lodash';
import ReactToPrint from "react-to-print";
import PrintIcon from '@material-ui/icons/Print';
import InstitutionProfile from '../commons/institution_profile'
import '../commons/commons.css'

import BookIcon from '@material-ui/icons/Book';

import {
  MuiPickersUtilsProvider,
  KeyboardDateTimePicker
} from '@material-ui/pickers';
import swal from 'sweetalert';
import commaNumber from 'comma-number';
let format = commaNumber.bindWith(',', '.')
const SalesRecord = ({location,currentRoute,currentRouteSet,authInfo})=>{
    const classes = useStyles();
    useEffect(()=>{
        currentRouteSet(pathSpliter(location.pathname,1));
        getPatients()
        getDoctors()
        // getAgents()
        getMarketers()
    },[]);
    let [employees,employeesSet] = useState([]);
    let [customers,customersSet] = useState([]);
    let [areas,areasSet] = useState([]);
    let [categories,categoriesSet] = useState([]);
    let [marketers,marketersSet] = useState([]);
    let [users,usersSet] = useState([]);
    let [agents,agentsSet] = useState([]);
    let [invoices,invoicesSet] = useState([]);
    let [selectedInvoice,selectedInvoiceSet] = useState(null);

    let [patients,patientsSet] = useState([]);
    let [doctors,doctorsSet] = useState([]);
    let [selectedPatient,selectedPatientSet] = useState(null);
    let [selectedDoctor,selectedDoctorSet] = useState(null);
    let [selectedAgent,selectedAgentSet] = useState(null);
    let [selectedMarketer,selectedMarketerSet] = useState(null);

    let [reportLoading,reportLoadingSet] = useState(false);
    
    let [selectedSearchType,selectedSearchTypeSet] = useState({searchType:'All'})
    let [selectedEmployee,selectedEmployeeSet] = useState(null)
    let [selectedCustomer,selectedCustomerSet] = useState(null)
    let [selectedProduct,selectedProductSet] = useState(null)
    let [selectedCategory,selectedCategorySet] = useState(null)
    let [selectedArea,selectedAreaSet] = useState(null)
    let [selectedUser,selectedUserSet] = useState(null)
    let [selectedRecordType,selectedRecordTypeSet] = useState({recordType:'Without Details'})

    let [individualProducts,setIndividualProducts] = useState([])
    let employeeRef = React.useRef(null)
    let [searchResult,searchResultSet] = useState([]);
    let [searchResultDetails,searchResultDetailsSet] = useState([]);
    let [saleProductDetail,saleProductDetailSet] = useState([]);
    let [saleProdCatDetail,saleProdCatDetailSet] = useState([]);
    let [print,printSet] = useState(false);


    let [types,typesSet] = useState([{
      agent_type: 'Hospital'
    },{
      agent_type: 'Diagnostic'
    }])
    
    let [selectedType,selectedTypeSet] = useState(null)

    
    let [recordTypes,recordTypesSet] = useState([{recordType:'Without Details'},{recordType:'With Details'}])
   
    const getCustomers = async ()=>{
          await axios.post(`${API_URL}/api/get-customers`,{'select-type':'active'},{headers:{'auth-token':authInfo.token}}).then(res=>{
            res.data.message.unshift({customer_id:0,customer_address:'',customer_mobile_no:'',customer_name:'General Customer',display_text:'General Customer'});
            customersSet(res.data.message);
          })
    }

    const getMarketers = async ()=>{
        await axios.post(`${API_URL}/api/get-marketers`,null,{headers:{'auth-token':authInfo.token}}).then(res=>{
          marketersSet(res.data.message)
        })
       }

    const getIndividualProducts = async()=>{
          await axios.post(`${API_URL}/api/get-individual-products`,{'select-type':'active'},{headers:{'auth-token':authInfo.token}}).then(res=>{
            setIndividualProducts(res.data.message);
          })
    }

    const getEmployees = async ()=>{
      await axios.post(`${API_URL}/api/get-employees`,{'select-type': "active"},{headers:{'auth-token':authInfo.token}}).then(res=>{
        employeesSet(res.data.message)
    })
    }

    const getAreas = async ()=>{
      await axios.post(`${API_URL}/api/get-areas`,{'select-type': "active"},{headers:{'auth-token':authInfo.token}}).then(res=>{
        areasSet(res.data.message)
    })
    }
  
    const getAgents = async ()=>{
      if(selectedType == null){
       swal({
         title:'Agent Type is Required.',
         icon:'warning'
       });
       return false
      }
     await axios.post(`${API_URL}/api/get-agents`,{'select-type':'active',
       agentType : selectedType.agent_type
   },{headers:{'auth-token':authInfo.token}}).then(res=>{
       agentsSet(res.data)
     })
    } 


    

    const getCategories = async ()=>{
        await axios.post(`${API_URL}/api/get-categories`,{'select-type': "active"},{headers:{'auth-token':authInfo.token}}).then(res=>{
          categoriesSet(res.data.message)
      })
      }

      const getPatients = async ()=>{
        await axios.post(`${API_URL}/api/get-patients`,null,{headers:{'auth-token':authInfo.token}}).then(res=>{
          patientsSet(res.data)
      })
      }

      const getDoctors = async ()=>{
        await axios.post(`${API_URL}/api/get-marketing-doctors`,null,{headers:{'auth-token':authInfo.token}}).then(res=>{
          doctorsSet(res.data.message)
      })
      }


      useEffect(()=>{
        getReceipts()
      },[selectedPatient])


      const getReceipts = async ()=>{
        if(selectedPatient != null){
          await axios.post(`${API_URL}/api/receipt-invoices`,{
            patientId : selectedPatient.patient_id
          },{headers:{'auth-token':authInfo.token}}).then(res=>{
            invoicesSet(res.data)
        })
        }
        
      }


      useEffect(()=>{
        selectedDoctorSet(null)
        selectedPatientSet(null)
        selectedUserSet(null)
        selectedAgentSet(null)
      },[selectedSearchType])

      const getUsers = async ()=>{
        await axios.post(`${API_URL}/api/get-users`,{'select-type': "active"},{headers:{'auth-token':authInfo.token}}).then(res=>{
          usersSet(res.data.message)
      })
      }

    let [byDateTime,byDateTimeSet] = useState({
          dateTimeFrom: currentDateStartTime(),
          dateTimeTo:currentDateEndTime()
    })


    let saleDelete = async (receiptId)=>{
        swal({
           title:'Are you sure delete this?',
           icon:'warning',
           buttons:true
        }).then(async (confirm)=>{
          if(confirm){
            await axios.post(`${API_URL}/api/receipt-delete`,{receiptId},{headers:{'auth-token':authInfo.token}}).then(res=>{
              if(!res.data.error){
               swal({
                 title:res.data.message,
                 icon:'success'
              })
              getSearchResult()
              } 
         })
          }else{
            return false
          }
          
        })
        
    }

    useEffect(()=>{ 

        if(selectedSearchType != null && selectedSearchType.searchType=='By Customer'){
          getCustomers();
        }

        if(selectedSearchType != null && selectedSearchType.searchType=='By Product'){
            getIndividualProducts();
        }

        if(selectedSearchType != null && selectedSearchType.searchType=='By Employee'){
            getEmployees();
        }

        if(selectedSearchType != null && selectedSearchType.searchType=='By Category'){
            getCategories();
        } 

        if(selectedSearchType != null && selectedSearchType.searchType=='By User'){
            getUsers();
        }

        if(selectedSearchType != null && selectedSearchType.searchType=='By Area'){
          getAreas();
      }

      selectedInvoiceSet(null)
      selectedPatientSet(null)
        
    },[selectedSearchType]);


    useEffect(()=>{
      if(selectedType != null){
        getAgents()

      }
      selectedAgentSet(null)
     },[selectedType])



    let [searchTypes,searchTypesSet] = useState([{searchType:'All'},
    {searchType:'By Doctor'},
    {searchType:'By Marketer'},
    // {searchType:'By Agent'},
    // {searchType:'By Patient'},
    // {searchType:'By User'},
    // {searchType:'By Group'},
    // {searchType:'By Test'},
  ]);

    
    let getSearchResult = async ()=>{

     
        let url = '';

                url = `${API_URL}/api/get-appointments`
            
            // if(selectedRecordType != null && selectedRecordType.recordType == 'With Details' ){ 
            //     url = `${API_URL}/api/get-sales-with-details`
            // }
            // if(selectedSearchType!=null && ( selectedSearchType.searchType=='By Group' || selectedSearchType.searchType=='By Test')){
            //   url = `${API_URL}/api/get-receipt-details`
            // }


            
        let reqPayload = {
            selectedSearchType: selectedSearchType != null?selectedSearchType.searchType:null,
            // userId: selectedUser != null ? selectedUser.user_id : null,
            doctorId: selectedDoctor != null ? selectedDoctor.id : null,
            marketer_id: selectedMarketer != null ? selectedMarketer.id : null,
            // agentId: selectedAgent != null ? selectedAgent.agent_id : null,
            // patientId: selectedPatient != null ? selectedPatient.patient_id : null,
            // receiptId: selectedInvoice != null ? selectedInvoice.receipt_id : null,
            dateTimeFrom: byDateTime.dateTimeFrom,
            dateTimeTo: byDateTime.dateTimeTo
        }

        
        reportLoadingSet(true)
        await axios.post(`${url}`,reqPayload,{headers:{'auth-token':authInfo.token}}).then(res=>{
             printSet(true)
             reportLoadingSet(false)
             searchResultSet(res.data.message);
            
      

            if(selectedSearchType != null && selectedSearchType.searchType=='By Group'){
               //

              let records =  res.data.message;

              records = _.chain(records)
                  .groupBy('prod_cat_id') 
                  .map(sale => {
                    return {
                      prod_cat_name: sale[0].prod_cat_name,
                      qty: _.sumBy(sale, item => Number(item.qty)),
                      amount: _.sumBy(sale, item => Number(item.total))
                        
                    }
                  })
                  .value();
              saleProdCatDetailSet(records)

               ///
            }


            
            if(selectedSearchType != null && selectedSearchType.searchType=='By Test'){
              //

             let records =  res.data.message;

             records = _.chain(records)
                 .groupBy('test_id') 
                 .map(sale => {
                   return {
                    prod_name: sale[0].prod_name,
                     qty: _.sumBy(sale, item => Number(item.qty)),
                     amount: _.sumBy(sale, item => Number(item.total))
                       
                   }
                 })
                 .value();
             saleProdCatDetailSet(records)

              ///
           }


        })



    }


    let ReportDom = React.forwardRef( (props,ref) =>{
        return(
          <div ref={ref}>
            
            <InstitutionProfile />
<div style={{clear:'both'}}></div>
<Paper style={{width:'100%',paddingLeft:'10px',paddingRight:'10px'}} className="print-source">
<p style={{width:'100%',textAlign:'center',fontWeight:'bold'}}>Appointment Record </p>

  <p style={{float:'left',width:'30%',textAlign:'left',margin:0,padding:0,fontSize:'16px'}}>
    {selectedSearchType != null && selectedSearchType.searchType == 'By Employee'?`Employee : ${selectedEmployee!=null?selectedEmployee.employee_name:''}`:''}
    {selectedSearchType != null && selectedSearchType.searchType == 'By Customer'?`Customer : ${selectedCustomer!=null?selectedCustomer.customer_name:''}`:''}<br/>
    {selectedSearchType != null && selectedSearchType.searchType == 'By Area'?`Area : ${selectedArea!=null?selectedArea.area_name:''}`:''}<br/>
    {selectedSearchType != null && selectedSearchType.searchType == 'By Customer'?`Customer Institution  : ${selectedCustomer!=null?selectedCustomer.customer_institution_name:''}`:''}
    {selectedSearchType != null && selectedSearchType.searchType == 'By Category'?`Category : ${selectedCategory!=null?selectedCategory.prod_cat_name:''}`:''}
    {selectedSearchType != null && selectedSearchType.searchType == 'By Product'?`Product : ${selectedProduct!=null?selectedProduct.prod_name:''}`:''}
    {selectedSearchType != null && selectedSearchType.searchType == 'By User'?`User : ${selectedUser!=null?selectedUser.user_name:''}`:''}
    </p>

<p style={{float:'right',width:'40%',textAlign:'right',margin:0,padding:0}}> Statement From { moment(byDateTime.dateTimeFrom).format(dateTimeFormat)  } <br/> TO { moment(byDateTime.dateTimeTo).format(dateTimeFormat) }
</p>
</Paper> 

        {
  (selectedSearchType != null &&  selectedSearchType.searchType ==  'By Product' && saleProductDetail.length>0 )?(
    <Paper className={classes.paper} style={{marginTop:'1px',marginBottom:'1px'}} >
    
    {/* sale product details */} 
    <TableContainer >
      <Table className={classes.table} size="small" aria-label="a dense table" className="report-dom">
        <TableHead>
          <TableRow> 
            <TableCell align="left">SL</TableCell>
            <TableCell align="left">Invoice No</TableCell>
            <TableCell align="left">Date & Time</TableCell>
            <TableCell align="left">Customer</TableCell>
            <TableCell align="right">Product Name</TableCell>
            <TableCell align="right">sale Rate</TableCell>
            <TableCell align="right">Quantity</TableCell>
            <TableCell align="right" className="print-no">Action</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
            {
              saleProductDetail.map((ele,index)=>(
                <TableRow  key={index}> 
                <TableCell  align="left">{index+parseFloat(1)}</TableCell>
                <TableCell align="left">{ele.sale_invoice}</TableCell> 
                <TableCell align="left">{moment(ele.sale_created_isodt).format(dateTimeFormat)}</TableCell>
                <TableCell align="left">{ele.customer_name}</TableCell>
                <TableCell align="right">{(ele.prod_name)}</TableCell>
                <TableCell align="right">{format((ele.sale_rate).toFixed(2))}</TableCell>
                <TableCell align="right">{(ele.sale_qty).toFixed(2)}</TableCell>
                 <TableCell align="right" className="print-no"> 
                 <Link to={{pathname:`/sales/sales-invoice/${ele.sale_id}`}}> <ReceiptIcon style={{cursor:'pointer',color:'black',marginLeft:'2px'}} > </ReceiptIcon></Link>
               {
                 authInfo.role !='user'?(
                   <>
                <Link to={{pathname:`/sales/sales-update/${ele.sale_id}`}}> 
                <EditIcon style={{cursor:'pointer',color:'green',marginLeft:'2px'}} > </EditIcon></Link>
                <DeleteIcon style={{cursor:'pointer',color:'#FF0202',marginLeft:'2px'}}  > </DeleteIcon>
                   </>
                 ):''
               }


             
                </TableCell>
              </TableRow>
              ))
            }
            
          

      
        <TableRow colSpan={4}>
          <TableCell></TableCell>
          <TableCell></TableCell>
          <TableCell></TableCell>
          <TableCell></TableCell>
          <TableCell></TableCell>
          <TableCell>Total Quantity : </TableCell>
        
          <TableCell align="right"> { saleProductDetail.reduce((prev,curr)=>{
                return prev+parseFloat(curr.sale_qty);
          },0).toFixed(2) }</TableCell>
         
          <TableCell></TableCell>
        </TableRow>
       


        </TableBody>
      </Table>
    </TableContainer>
        </Paper>
  ):''
}


{
  (selectedRecordType !=null && selectedSearchType != null &&  selectedSearchType.searchType !=  'By Product' && selectedSearchType.searchType !=  'By Group' && selectedSearchType.searchType !=  'By Test' && searchResult.length>0 &&  selectedRecordType.recordType=='Without Details')?(
    <Paper className={classes.paper} style={{marginTop:'1px',marginBottom:'1px'}} >
    
    {/* sale Record  without details */} 
    <TableContainer >
      <Table className={classes.table} size="small" aria-label="a dense table" className="report-dom">
        <TableHead>
          <TableRow> 
            <TableCell align="left"  style={{width:'1%'}}>Count</TableCell>
            <TableCell align="left"  style={{width:'10%'}}>Name</TableCell>
            <TableCell align="left"  style={{width:'10%'}}>Serial No</TableCell>
            <TableCell align="left"  style={{width:'7%'}}>Date</TableCell>
            <TableCell align="left"  style={{width:'10%'}}>Doctor</TableCell>
            <TableCell align="left"  style={{width:'10%'}}>Mobile No</TableCell>
            <TableCell align="left"  style={{width:'6%'}}>Address</TableCell>
           
          </TableRow>
        </TableHead>
        <TableBody>
            {
              searchResult.map((ele,index)=>(
                <TableRow  key={index}> 
                <TableCell  align="left">{index+parseFloat(1)}</TableCell>
                <TableCell align="left">{ele.name}</TableCell> 
                <TableCell align="left">{ele.serial}</TableCell> 
                <TableCell align="left">{moment(ele.create_date).format('DD MMM Y')}</TableCell>
                <TableCell align="left">{ele.doctor_name}</TableCell> 
                <TableCell align="left">{ele.mobile_no}</TableCell>
                <TableCell align="left">{ele.address}</TableCell>


             
              </TableRow>
              ))
            }
            
          

      
    


        </TableBody>
      </Table>
    </TableContainer>
        </Paper>
  ):''
}
        




          {/* Category wise Details */}
      {
        ( selectedSearchType != null && selectedSearchType.searchType ==  'By Group' && saleProdCatDetail.length>0)?(
          <Paper className={classes.paper} style={{marginTop:'1px',marginBottom:'1px'}} >
    
    <TableContainer >
      <Table className={classes.table} size="small" aria-label="a dense table" className="report-dom">
        <TableHead>
          <TableRow>
            <TableCell align="left" width="30%">Group Name</TableCell>
            <TableCell align="right" width="20%">Qty</TableCell>
            <TableCell align="right" width="20%">Amount</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
            {
              saleProdCatDetail.map((ele,index)=>(
                <>
                <TableRow  key={index}  > 
                <TableCell align="left">{ele.prod_cat_name}</TableCell>
                <TableCell align="right">{ele.qty}</TableCell>
                <TableCell align="right">{ele.amount}</TableCell>

                </TableRow>

                  
              
                </>))
            }

<TableRow   > 
                <TableCell colSpan={1} align='right'>Total : </TableCell>
                <TableCell align="right">
                {format(saleProdCatDetail.reduce((prev,curr)=>{
                     return prev+parseFloat(curr.qty)
            },0).toFixed(2))}
                </TableCell>
                <TableCell align="right">
                {format(saleProdCatDetail.reduce((prev,curr)=>{
                     return prev+parseFloat(curr.amount)
            },0).toFixed(2))}
                </TableCell>

                </TableRow>

            
        </TableBody>
      </Table>
    </TableContainer>
        </Paper>
        ):'' 
      }


{
        ( selectedSearchType != null && selectedSearchType.searchType ==  'By Test' && saleProdCatDetail.length>0)?(
          <Paper className={classes.paper} style={{marginTop:'1px',marginBottom:'1px'}} >
    
    <TableContainer >
      <Table className={classes.table} size="small" aria-label="a dense table" className="report-dom">
        <TableHead>
          <TableRow>
            <TableCell align="left" width="30%">Test Name</TableCell>
            <TableCell align="right" width="20%">Qty</TableCell>
            <TableCell align="right" width="20%">Amount</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
            {
              saleProdCatDetail.map((ele,index)=>(
                <>
                <TableRow  key={index}  > 
                <TableCell align="left">{ele.prod_name}</TableCell>
                <TableCell align="right">{ele.qty}</TableCell>
                <TableCell align="right">{ele.amount}</TableCell>

                </TableRow>

                  
              
                </>))
            }

<TableRow   > 
                <TableCell colSpan={1} align='right'>Total : </TableCell>
                <TableCell align="right">
                {format(saleProdCatDetail.reduce((prev,curr)=>{
                     return prev+parseFloat(curr.qty)
            },0).toFixed(2))}
                </TableCell>
                <TableCell align="right">
                {format(saleProdCatDetail.reduce((prev,curr)=>{
                     return prev+parseFloat(curr.amount)
            },0).toFixed(2))}
                </TableCell>

                </TableRow>

            
        </TableBody>
      </Table>
    </TableContainer>
        </Paper>
        ):'' 
      }

        {/* With Details */}
      {
        (selectedRecordType != null && selectedSearchType != null && selectedSearchType.searchType !=  'By Product' && selectedSearchType.searchType !=  'By Category' && searchResultDetails.length>0 && selectedRecordType.recordType=='With Details')?(
          <Paper className={classes.paper} style={{marginTop:'1px',marginBottom:'1px'}} >
    
    <TableContainer >
      <Table className={classes.table} size="small" aria-label="a dense table" className="report-dom">
        <TableHead>
          <TableRow>
            <TableCell align="left">SL</TableCell>
            <TableCell align="left">Invoice No</TableCell>
            <TableCell align="left">Date</TableCell>
            <TableCell align="left">Doctor</TableCell>
            <TableCell align="left">Patient</TableCell>
            <TableCell align="right">Amount</TableCell> 
            <TableCell align="right" className="print-no">Actions</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
            {
              searchResultDetails.map((ele,index)=>(
                <>
                <TableRow  key={index}> 
                <TableCell  align="left">{index+parseFloat(1)}</TableCell>
                <TableCell align="left">{ele.sale_invoice}</TableCell> 
                <TableCell align="left">{moment(ele.sale_created_isodt).format(dateTimeFormat)}</TableCell>
                <TableCell align="left">{ele.doctor_name}</TableCell>
                <TableCell align="left">{ele.details[0].prod_name}</TableCell>
                <TableCell align="right">{format(ele.details[0].sale_rate)}</TableCell>
                <TableCell align="right">{ele.details[0].sale_qty}</TableCell>
                <TableCell align="right">{format((ele.details[0].sale_prod_total).toFixed(2))}</TableCell>

                 <TableCell align="right" className="print-no">
                 <Link to={{pathname:`/sales/sales-invoice/${ele.sale_id}`}}>   <ReceiptIcon style={{cursor:'pointer',color:'black',marginLeft:'2px'}} > </ReceiptIcon></Link>
             
             {
                authInfo.role !='user'?(<>
                 <Link to={{pathname:`/sales/sales-update/${ele.sale_id}`}}> 
             <EditIcon style={{cursor:'pointer',color:'green',marginLeft:'2px'}} > </EditIcon>
             </Link> 
                <DeleteIcon onClick={()=>{saleDelete(ele.sale_id)}} style={{cursor:'pointer',color:'#FF0202',marginLeft:'2px'}} > </DeleteIcon>
                </>):''
             }
            
                </TableCell>
              </TableRow>

                  
                {
                  ele.details.slice(1).map((detail,dIndex)=>(
                    <TableRow key={dIndex}> 
                      <TableCell  align="left"></TableCell>
                      <TableCell  align="left"></TableCell>
                      <TableCell  align="left"></TableCell>
                      <TableCell  align="left"></TableCell>
                    <TableCell  align="left">{detail.prod_name}</TableCell>
                    <TableCell  align="right">{format(detail.sale_rate)}</TableCell>
                    <TableCell  align="right">{detail.sale_qty}</TableCell>
                    <TableCell  align="right">{format((detail.sale_prod_total).toFixed(2))}</TableCell>
                    </TableRow>
                  ))

                }



                    <TableRow> 
                      <TableCell  align="left"></TableCell>
                      <TableCell  align="left"></TableCell>
                      <TableCell  align="left"></TableCell>
                      <TableCell  align="left"></TableCell>
                    <TableCell  align="left"></TableCell>
                    <TableCell  align="left"></TableCell>
                  <TableCell  align="right">Total Quantity : {ele.details.reduce((prev,curr)=>{
                           return prev+parseFloat(curr.sale_qty)
                  },0).toFixed(2)}</TableCell>
                    <TableCell  align="right">
                      Total : {format((ele.sale_total_amount).toFixed(2))}<br/>
                   Paid :  {format((ele.sale_paid_amount).toFixed(2))}<br/>
                   Due :  {format((ele.sale_due_amount).toFixed(2))}
                  </TableCell>
                    <TableCell  align="right"></TableCell>
                    </TableRow>
                   </>
                
      ))
            }

            {
                <TableRow> 
                <TableCell  align="left"></TableCell>
                <TableCell  align="left"></TableCell>
                <TableCell  align="left"></TableCell>
                <TableCell  align="left"></TableCell>
              <TableCell  align="left"></TableCell>
              <TableCell  align="left"></TableCell>
              <TableCell  align="left"></TableCell>
            <TableCell  align="right">Total Amount : {format(searchResultDetails.reduce((prev,curr)=>{
                     return prev+parseFloat(curr.sale_total_amount)
            },0).toFixed(2))}<br/> 
            Total Paid :{format(searchResultDetails.reduce((prev,curr)=>{
                     return prev+parseFloat(curr.sale_paid_amount)
            },0).toFixed(2))} <br/> 
            Total Due : {format(searchResultDetails.reduce((prev,curr)=>{
                     return prev+parseFloat(curr.sale_due_amount)
            },0).toFixed(2))} </TableCell>

              <TableCell  align="right"></TableCell>
              <TableCell  align="right"></TableCell>
              </TableRow>
            }
        </TableBody>
      </Table>
    </TableContainer>
        </Paper>
        ):''
      }
          </div>
        )
    })




    const reportRef = useRef();

   

      return(
          <div className={classes.root}> 
<Paper className={classes.paper} style={{marginTop:'-25px',marginBottom:'5px'}}>
<h4 style={{textAlign:'left',margin:0,padding:0,marginTop: '-10px',
    marginBottom: '2px'}}>Appointment Record</h4>
<Grid container spacing={3} > 
          <Grid item  xs={12}  sm={2}> 
          <Autocomplete 
          size="small"
          autoHighlight
              openOnFocus={true}
              style={{width:'100%',height:'20px'}}
              options={searchTypes} 
              value={selectedSearchType}
              getOptionLabel={(option) => option.searchType}
              onChange={(event,selectedObj)=>{
                selectedSearchTypeSet(selectedObj) 
              }}
              renderInput={(params) => <TextField 
                inputRef={employeeRef}
               
                {...params} 
                label="Search Type" 
                variant="outlined"
                />} 
          />

          </Grid>



          <Grid item xs={12} sm={2} className={classes.plusLinkDiv}  style={{display: selectedSearchType!=null && selectedSearchType.searchType=='By Agent'?'block':'none'}}>
                    <Autocomplete

                    autoHighlight={true}
                    size="small"
                    openOnFocus={true}
                    style={{width:'100%'}}
                    options={types}
                    value={selectedType}
                    loading={true}
                    onChange={async (e,patient)=>{

                    selectedTypeSet(patient)

                    }}
                    getOptionLabel={(option) => option.agent_type}
                    renderInput={(params) => <TextField 
                    
                    {...params} 
                    label="Agent Type" 
                    variant="outlined"
 
                    />}
                    />



                    </Grid>



          <Grid item  xs={12}   sm={2} style={{display: selectedSearchType!=null && selectedSearchType.searchType=='By Area'?'block':'none'}}> 
          <Autocomplete 
          size="small"
          autoHighlight
              openOnFocus={true}
              style={{width:'100%',height:'20px'}} 
              options={areas}
              value={selectedArea}
              getOptionLabel={(option) => option.area_name}
              onChange={(event,selectedObj)=>{
                 selectedAreaSet(selectedObj);
              }}
              renderInput={(params) => <TextField                
                {...params} 
                label="Select Area" 
                variant="outlined"
                />} 
                
          />
          </Grid>


          <Grid item  xs={12}   sm={2} style={{display: selectedSearchType!=null && selectedSearchType.searchType=='By Doctor'?'block':'none'}}> 
          <Autocomplete 
          size="small"
          autoHighlight
              openOnFocus={true}
              style={{width:'100%',height:'20px'}} 
              options={doctors}
              value={selectedDoctor}
              getOptionLabel={(option) => option.display_text}
              onChange={(event,selectedObj)=>{
                 selectedDoctorSet(selectedObj);
              }}
              renderInput={(params) => <TextField                
                {...params} 
                label="Select Doctor" 
                variant="outlined"
                />} 
                
          />
          </Grid>

          <Grid item xs={12} sm={3} style={{display: selectedSearchType!=null && selectedSearchType.searchType=='By Marketer'?'block':'none'}}>
      <Autocomplete
        autoHighlight={true}
        openOnFocus={true}
      style={{ width: '100%' }}
      options={marketers} 
      size="small"
      classes={{
        option: classes.option,
      }}
      
      getOptionLabel={(option) => option.name}
     value={selectedMarketer}
     onChange={(event,selectedObj)=>{
      selectedMarketerSet(selectedObj)
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          label="Choose a Marketer"
          variant="outlined"
         
        />
      )}
    />
  </Grid>



          <Grid item  xs={12}   sm={2} style={{display: selectedSearchType!=null && selectedSearchType.searchType=='By Agent'?'block':'none'}}> 
          <Autocomplete 
          size="small"
          autoHighlight
              openOnFocus={true}
              style={{width:'100%',height:'20px'}} 
              options={agents}
              value={selectedAgent}
              getOptionLabel={(option) => option.agent_name}
              onChange={(event,selectedObj)=>{
                 selectedAgentSet(selectedObj);
              }}
              renderInput={(params) => <TextField                
                {...params} 
                label="Select Agent" 
                variant="outlined"
                />} 
                
          />
          </Grid>



         


          <Grid item  xs={12}   sm={2} style={{display: selectedSearchType!=null && selectedSearchType.searchType=='By Patient'?'block':'none'}}> 
          <Autocomplete 
          size="small"

          autoHighlight
              openOnFocus={true}
              style={{width:'100%',height:'20px'}}
              options={patients}
              value={selectedPatient}
              getOptionLabel={(option) => option.display_text}
              onChange={(event,selectedObj)=>{
                 selectedPatientSet(selectedObj)
              }}
              renderInput={(params) => <TextField 
                inputRef={employeeRef}
                onKeyDown={event => {
                  if (event.key === "Enter") {
                     // saleDateRef.current.focus()
                  }
                }} 
                {...params} 
                label="Select Patient" 
                variant="outlined"
                />} 
                
          />
          </Grid>


          <Grid item  xs={12}   sm={2} style={{display: selectedSearchType!=null && selectedSearchType.searchType=='By Patient'?'block':'none'}}> 
          <Autocomplete 
          size="small"

          autoHighlight
              openOnFocus={true}
              style={{width:'100%',height:'20px'}}
              options={invoices}
              value={selectedInvoice}
              getOptionLabel={(option) => option.receipt_no}
              onChange={(event,selectedObj)=>{
                selectedInvoiceSet(selectedObj)
              }}
              renderInput={(params) => <TextField 
                inputRef={employeeRef}
                onKeyDown={event => {
                  if (event.key === "Enter") {
                     // saleDateRef.current.focus()
                  }
                }} 
                {...params} 
                label="Select Receipt" 
                variant="outlined"
                />} 
                
          />
          </Grid>



          <Grid item  xs={12}   sm={2} style={{display: selectedSearchType!=null && selectedSearchType.searchType=='By Category'?'block':'none'}}> 
          <Autocomplete 
          size="small"
          autoHighlight
              openOnFocus={true}
              style={{width:'100%',height:'20px'}}
              options={categories}
              value={selectedCategory}
              getOptionLabel={(option) => option.prod_cat_name}
              onChange={(event,selectedObj)=>{
                 selectedCategorySet(selectedObj)
              }}
              renderInput={(params) => <TextField 
                {...params} 
                label="Select Category" 
                variant="outlined"
                />} 
                
          />
          </Grid>

          <br></br>
          
          <Grid item  xs={12}   sm={2} style={{display: selectedSearchType!=null && selectedSearchType.searchType=='By Product'?'block':'none'}}> 
          <Autocomplete  
          size="small"
          autoHighlight
              openOnFocus={true}
              style={{width:'100%',height:'20px'}}
              options={individualProducts}
              value={selectedProduct} 
              getOptionLabel={(option) => option.prod_name}
              onChange={(event,selectedObj)=>{
                 selectedProductSet(selectedObj)
              }}
              renderInput={(params) => <TextField 
                {...params} 
                label="Select Product" 
                variant="outlined"
                />} 
                 
          />
          </Grid>

        

          <Grid item  xs={12}   sm={2} style={{display: selectedSearchType!=null && selectedSearchType.searchType=='By User'?'block':'none'}}> 
          <Autocomplete  
          size="small"
          autoHighlight
              openOnFocus={true}
              style={{width:'100%',height:'20px'}}
              options={users}
              value={selectedUser} 
              getOptionLabel={(option) => option.user_name}
              onChange={(event,selectedObj)=>{
                 selectedUserSet(selectedObj)
              }}
              renderInput={(params) => <TextField 
                {...params} 
                label="Select user" 
                variant="outlined"
                />} 
                
          />
          </Grid>
{/* {
  selectedSearchType != null && !(selectedSearchType.searchType=='By Product' || selectedSearchType.searchType=='By Category'  || selectedSearchType.searchType=='By Area')?(
    <Grid item  xs={12}   sm={2}  > 
    <Autocomplete  
    size="small"
    autoHighlight
        openOnFocus={true}
        style={{width:'100%',height:'20px'}} 
        options={recordTypes} 
        value={selectedRecordType} 
        getOptionLabel={(option) => option.recordType}
        onChange={(event,selectedObj)=>{
          selectedRecordTypeSet(selectedObj);
        }}
        renderInput={(params) => <TextField                
          {...params} 
          label="Record Type" 
          variant="outlined"
          />} 
          
    />
    </Grid>
  ):''
}
          */}



          
              
          <Grid item  xs={12}  sm={2} style={{marginBottom: '-9px'}} > 
            <MuiPickersUtilsProvider  utils={DateFnsUtils} > 
          
            <KeyboardDateTimePicker
          //  inputRef={saleDateRef}
            onKeyDown={(e)=>{
              if(e.key==='Enter'){
                //supplierRef.current.focus()
              }
            }}
            style={{ width: '100%',marginTop: '' }}
            value={byDateTime.dateTimeFrom}
            onChange={(datet)=>{
              byDateTimeSet({...byDateTime,dateTimeFrom:datet})
            }}
            label="From Date &   Time"
            format="Y/MM/d hh:mm a"
            /> 
            </MuiPickersUtilsProvider>
          </Grid>


          <Grid item  xs={12}  sm={2} style={{marginBottom: '-9px'}} > 
            <MuiPickersUtilsProvider  utils={DateFnsUtils} > 
          
            <KeyboardDateTimePicker
            //inputRef={saleDateRef}
            onKeyDown={(e)=>{
              if(e.key==='Enter'){
               // supplierRef.current.focus()
              }
            }}
            style={{ width: '100%',marginTop: '' }}
            value={byDateTime.dateTimeTo}
            onChange={(datet)=>{
              byDateTimeSet({...byDateTime,dateTimeTo:datet})
            }}
            label="To Date &   Time"
            format="yyyy/MM/dd hh:mm a"
               />
            </MuiPickersUtilsProvider>
          </Grid>
          <Grid item  xs={12}   sm={1} >
        <Button style={{marginTop: '5px',marginLeft: 'auto',fontSize:'10px'}} 
                            variant="contained"
                            color="primary"
                            className={classes.button}
                            startIcon={<SearchIcon/>}
                            onClick={getSearchResult}
                            disabled={reportLoading?true:false}
                        >
                        Report 
                      </Button>
        </Grid>

        </Grid> 
        
        </Paper>
        {
          print?(
            <Grid container >
            <Grid item xs={12} sm={12} >
              <Paper style={{borderRadius:'0px',marginTop: '-7px'}}>
              <ReactToPrint
                          trigger={() => <PrintIcon  style={{cursor:'pointer',marginLeft: '30px',marginTop: '3px',marginBottom: '-8px'}} />}
                          content={() => reportRef.current}
                        />
              </Paper>
           
            </Grid>
        </Grid>
          ):''
        }
      
            <ReportDom ref={reportRef} /> 




          </div>
      )
}



const useStyles = makeStyles((theme) => ({
    root: {
      flexGrow: 1,
    },
    inputField:{
      width:'100%',
      marginTop:'5px'
    },
    plusLinkDiv:{
      position:'relative'  
    },
    plusLink:{
      margin: 0,
      padding: 0,
      marginTop: '-21px',
      fontSize: '29px',
      height: '21px',
      textAlign: 'right',
      position: 'absolute',
      right: 0,
      color: '#3e8d54'
    },
    paper: {
      padding: theme.spacing(1),
      textAlign: 'center',
      color: theme.palette.text.secondary,
    },
  }));


const mapStateToPops = (state)=>{
      return {
        currentRoute:state.currentRouteReducer,
        authInfo:state.authInfoReducer
      }
}
export default connect(mapStateToPops,{currentRouteSet})(SalesRecord); 